export const changePasswordTypes = {
    changeUserPassword: 'userPassword',
    changeCompanyPassword: 'companyPassword'
}